import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type ResourceImageReferenceId = Branded<string, "ResourceImageReferenceId">;
const resourceImageReferenceIdPrefix = "resource-image_reference__";
const {
    factory: resourceImageReferenceIdFactory,
    assert: isResourceImageReferenceId,
    zodSchema: resourceImageReferenceIdZodSchema,
} = genericId<ResourceImageReferenceId>(resourceImageReferenceIdPrefix);

export {
    isResourceImageReferenceId,
    resourceImageReferenceIdFactory,
    resourceImageReferenceIdPrefix,
    resourceImageReferenceIdZodSchema,
};
export type { ResourceImageReferenceId };
